<template>
  <v-form ref="rosconForm" lazy-validation v-model="isValid">
    <v-container style="padding: 0 2rem;">
      <!-- RECUPERAR DATOS, CORREDORES INSCRIPCIÓN MULTIPLE -->
      <v-row>
        <v-dialog v-model="recuperar" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-col cols="12" sm="6" md="4" offset-md="4">
              <v-btn block large color="orange darken-1" v-on="on">Recuperar datos del año anterior
              </v-btn>
            </v-col>

          </template>
          <v-card>
            <v-card-title>
              <span class="headline myModal">Por favor, introduce tu DNI</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="DNI" placeholder="12345678A" required
                                  v-model="recuperarDni" maxlength="9"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="noEncontrado" cols="12" sm="6" md="4">
                    <h4>No hemos podido encontrarte</h4>
                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="recuperar = false">Cerrar</v-btn>
              <v-btn color="blue darken-1" text :disabled="recuperarDni.length < 9"
                     @click="recuperaInscripcion">Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="verInscritos" v-if="multiple" persistent max-width="800px">
          <template v-slot:activator="{ on }">
            <v-col cols="12" sm="6" md="4">
              <v-badge color="green" overlap>
                <template v-slot:badge>
                  <span>{{ $store.state.inscritos.length }}</span>
                </template>
                <span>
                  <v-btn block large color="blue darken-1" v-on="on">
                    CORREDORES DE ESTA INSCRIPCIÓN
                  </v-btn>
                </span>
              </v-badge>

            </v-col>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline myModal">Corredores que forman la inscripción actual</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-simple-table fixed-header height="300px">
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <td>Nombre</td>
                          <td>Apellidos</td>
                          <td>DNI</td>
                          <td>Email</td>
                          <td>&nbsp;</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="persona in $store.state.inscritos" :key="persona.dni">
                          <td>{{ persona.nombre }}</td>
                          <td>{{ persona.apellidos }}</td>
                          <td>{{ persona.dni }}</td>
                          <td>{{ persona.email }}</td>
                          <td>
                            <v-btn fab dark small color="red lighten-1"
                                   @click="borrarCorredor(persona.dni)">
                              <v-icon dark>delete</v-icon>
                            </v-btn>

                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success darken-1" text @click="irResumen">Pagar</v-btn>
              <v-btn color="blue darken-1" text @click="verInscritos = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- NOMBRE, APELLIDOS, FNAC -->
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
                  label="Nombre"
                  prepend-icon="face"
                  v-model.trim="persona.nombre"
                  required
                  :rules="rules.nombre"
          >
            <template v-slot:label>
              Nombre<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  prepend-icon="face"
                  v-model.trim="persona.apellidos"
                  required
                  :rules="rules.apellidos"

          >
            <template v-slot:label>
              Apellidos<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <datePicker
                  @change="cambia"
                  required
                  v-model.trim="persona.fnac"
                  :current="currentDate"
                  max="2020-01-29"
                  v-if="viewDate"
          >
            <template v-slot:append-outer>
              <v-icon small color="primary">*</v-icon>
            </template>
          </datePicker>
        </v-col>
      </v-row>

      <!-- DNI, LOCALIDAD, GENERO -->
      <v-row>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  prepend-icon="fingerprint"
                  v-model.trim="persona.dni"
                  required
                  :rules="rules.dni"
                  maxlength="9"
          >
            <template v-slot:label>
              DNI<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  prepend-icon="location_city"
                  v-model.trim="persona.localidad"
                  :rules="rules.localidad"
          >
            <template v-slot:label>
              Localidad de residencia<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-radio-group row label="Genero"
                         v-model="persona.sexo"
                         required
                         :rules="rules.sexo"
          >
            <v-radio label="Hombre" value="V"

            ></v-radio>
            <v-radio label="Mujer" value="F"


            ></v-radio>
            <template v-slot:label>
              Genero<sup>
              *
            </sup>
            </template>
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- EMAIL, TFNO, SOCIO -->
      <v-row>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  prepend-icon="email"
                  v-model.trim="persona.email"
                  :rules="rules.email"
                  required
          >
            <template v-slot:label>
              Correo electrónico<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  label="Teléfono de contacto"
                  prepend-icon="phone"
                  v-model.trim="persona.tlfno"
                  required
                  :rules="rules.tlfno"
                  maxlength="9"

          >
            <template v-slot:label>
              Teléfono de contacto<sup>
              *
            </sup>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-radio-group row label="¿Eres socio de Os Andarines de Aragón?"
                         v-model.trim="persona.socio"
                         required
                         :rules="rules.socio"
                         @change="cambiaSocio"
          >
            <template v-slot:label>
              <span style="font-size: 1.05rem;">¿Eres socio de Os Andarines de Aragón?</span>
            </template>
            <v-radio label="SI" value="SI"

            ></v-radio>
            <v-radio label="NO" value="NO"

            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- DATOS DEL TUTOR -->
      <v-banner v-model="isMenor" transition="slide-y-transition" elevation="4" color="blue lighten-1">
        <v-row>
          <v-col cols="12">
            <h2 class="text-center">Datos del padre, madre o tutor</h2><br>
            <p>Por ser menor de 18 años se debe facilitar los datos de una persona mayor de edad que actuará
              como tutor y se responsabilizará de que el menor esté capacitado para participar en la
              carrera.</p>
          </v-col>
          <v-col cols="12" sm="6" md="4" >
            <v-text-field
                    prepend-icon="face"
                    v-model.trim="persona.nombre_tutor"
                    :rules="rules.nombre_tutor"
                    :required="isMenor"
            >
              <template v-slot:label>
                Nombre y apellidos del tutor<sup>
                *
              </sup>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" >
            <v-text-field
                    label="DNI del tutor"
                    prepend-icon="fingerprint"
                    v-model.trim="persona.dni_tutor"
                    :rules="rules.dni_tutor"
                    :required="isMenor"
                    maxlength="9"
            >
              <template v-slot:label>
                DNI del tutor<sup>
                *
              </sup>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" >
            <v-text-field
                    label="Teléfono de contacto"
                    prepend-icon="phone"
                    v-model.trim="persona.tlfno_tutor"
                    :rules="rules.tlfno_tutor"
                    :required="isMenor"
                    maxlength="9"
            >
              <template v-slot:label>
                Teléfono de contacto<sup>
                *
              </sup>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-banner>

      <!-- CATEGORIA, MARCA, APODO -->
      <v-row>
        <v-col cols="12" sm="6" md="4" >
          <v-select
                  :items="categorias"
                  prepend-icon="group_work"
                  label="Categoría"
                  v-model.trim="persona.idCategoria"
                  item-text="nombre"
                  item-value="id"
                  readonly
          >
            <template v-slot:append-outer>
              <v-dialog v-model="infoCategoria" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-icon small color="primary" v-on="on">info</v-icon>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Información sobre las categorías</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text>
                            La categoría se asigna automáticamente en función de la fecha de nacimiento. Si por el
                            motivo que fuese deseases correr en otra categoría, por ejemplo en la Absoluta, debes
                            informarlo en el apartado de ‘Observaciones’ de más abajo.
                          </v-text>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="infoCategoria = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-select
                  :items="marcas"
                  prepend-icon="watch_later"
                  v-model="persona.marca"
                  required
                  :rules="rules.marca"
          >
            <template v-slot:label>
              Marca prevista<sup>
              *
            </sup>
            </template>
            <template v-slot:append-outer>
              <v-dialog v-model="infoMarca" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-icon small color="primary" v-on="on">info</v-icon>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Información de marca prevista</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <p class="text-justify">
                            Por favor, por respeto a los demás corredores, se honesto con la
                            marca que puedes hacer.
                          </p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="infoMarca = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
                  label="Apodo"
                  prepend-icon="label"
                  v-model="persona.apodo"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- FEDERADO, LICENCIA, CLUB -->
      <v-row>
        <v-col cols="12" sm="6" md="4" >
          <v-radio-group row
                         v-model.trim="persona.federado"
                         required
                         :rules="rules.federado"
                         @change="cambiaFederado"
          >
            <template v-slot:label>
              Federado en atletismo<sup>
              *
            </sup>
            </template>
            <v-radio label="SI" value="SI"

            ></v-radio>
            <v-radio label="NO" value="NO"

            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-text-field
                  label="Nº de Licencia Atletismo"
                  prepend-icon="credit_card"
                  placeholder="Obligatorio para atletas federados"
                  v-model="persona.licencia"
                  :required="persona.federado === 'SI'"
                  :rules="rules.licencia"
                  :disabled="persona.federado === 'NO' || persona.federado === ''"


          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
                  label="Club"
                  prepend-icon="group"
                  v-model="persona.club"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- CAMISETA, TALLA, DUCHAS -->
      <v-row>
        <v-col cols="12" sm="6" md="4" >
          <v-radio-group row
                         v-model="persona.camiseta"
                         required
                         :rules="rules.camiseta"
                         @change="cambiaCamiseta"
          >
            <template v-slot:label>
              Quiero camiseta<sup>
              *
            </sup>
            </template>
            <v-radio label="SI" value="SI"

            ></v-radio>
            <v-radio label="NO" value="NO" :disabled="persona.socio === 'SI'" ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-select
                  :items="tallas"
                  prepend-icon="list"
                  label="Talla de la camiseta"
                  :disabled="(persona.camiseta === 'NO' || persona.camiseta === '')"
                  :required="persona.federado === 'SI'"
                  :rules="rules.talla"
                  v-model="persona.talla"
                  @blur="rules.talla"

          >
            <template v-slot:append-outer>
              <v-dialog v-model="infoTallas" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-icon small color="primary" v-on="on">info</v-icon>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Tallas según disponibilidad</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-img src="@/assets/tallas_camisetas.jpg"
                                 lazy-src="@/assets/tallas_camisetas.jpg"
                                 ></v-img>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="infoTallas = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" >
          <v-radio-group row
                         v-model.trim="persona.ducha"
                         required
                         :rules="rules.ducha"

          >
            <template v-slot:label>
              Uso de servicio de DUCHAS en CDM Siglo XXI<sup>
              *
            </sup>
            </template>
            <v-radio label="SI" value="SI"


            ></v-radio>
            <v-radio label="NO" value="NO"


            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- OBSERVACIONES -->
      <v-banner elevation="2" single-line icon="info" icon-color="blue lighten-1" >
        <v-row style="width: 75%; ">
          <v-col cols="6">
            <p>
              <small><i>Antes del 15-01-2020</i></small>
            </p>
            <ul><small><i>
              <li>
                Inscripción + camiseta: 16 €
              </li>
              <li>
                Sólo Inscripción: 12.50 €
              </li>

            </i></small></ul>
            <p></p>
          </v-col>
          <v-col cols="6">
            <p><small><i>A partir del 16-01-2020</i></small></p>
            <ul><small><i>
              <li>
                Precio único y obligatorio de 20 € (incluye camiseta)
              </li>
            </i></small></ul>
          </v-col>
        </v-row>
      </v-banner>
      <v-row>
        <v-col cols="12">
          <v-textarea
                  name="observaciones"
                  label="Observaciones"
                  v-model="persona.observaciones"
          ></v-textarea>
        </v-col>
      </v-row>
      <br>
      <!-- REGLAMENTO Y BOTONES -->
      <v-row>
        <v-col cols="12" >
          <v-checkbox
                  v-model.trim="persona.condiciones"
                  required
                  :rules="rules.condiciones"
                  @change="validarForm"
          >
            <template v-slot:label>
              <div>
                He leído y acepto las condiciones detalladas en el
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                            target="_blank"
                            href="http://osandarines.com/secciones/atletismo/10kroscon-2/reglamento_10kroscon-2/"
                            @click.stop
                            v-on="on"
                    >
                      Reglamento de la carrera
                    </a>
                  </template>
                  Se abre en una nueva pestaña
                </v-tooltip>
              </div>
              <sup>
                *
              </sup>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="6">
          <v-btn block large color="success darken-3" @click="pagar">Pagar</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn block large color="info lighten-1" @click="agregarCorredor" :disabled="$store.state.inscritos.length >= 9" >
            Agregar otro corredor
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="duplicado" persistent max-width="600px">
        <template v-slot:activator="{ on }">

        </template>
        <v-card>
          <v-card-title>
            <span class="headline myModal">Aviso</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <h4>Ya hay un participante inscrito con este DNI</h4>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="duplicado = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
  import DatepickerComponent from "./shared/DatepickerComponent"
  import moment from 'moment'
  import {cat, tallas} from './../config'
  import {mapActions, mapGetters} from 'vuex'

  import {insService} from './../_services'

  /* eslint-disable no-debugger */

  export default {
    name: 'diezForm',
    data() {
      return {
        isValid: false,
        duplicado: false, // Si la inscripcion esta duplicada
        noEncontrado: false, // Si no encuentra un corredor del año pasado
        agregar: true,
        verInscritos: false,
        multiple: false,
        currentDate: null,
        viewDate: true,
        nombre: '',
        recuperar: false,
        recuperarDni: '',
        reglamento: false,
        infoTallas: false,
        infoMarca: false,
        infoCategoria: false,
        isMenor: false,
        marcas: ['menos de 30\'', '30\' - 35\'', '35\' - 40\'', '40\' - 50\'', '50\' - 60\'', 'más de 60\''],
        tallas: [],
        categorias: [],
        diaCarrera: moment('2020-01-29'),
        persona: {
          nombre: '',
          apellidos: '',
          fnac: '',
          dni: '',
          localidad: '',
          sexo: '',
          email: '',
          tlfno: '',
          socio: '',
          nombre_tutor: '',
          dni_tutor: '',
          tlfno_tutor: '',
          idCategoria: '',
          marca: '',
          apodo: '',
          federado: '',
          licencia: '',
          club: '',
          camiseta: '',
          talla: '',
          ducha: '',
          observaciones: '',
          condiciones: false,
          menor: false,
          idCarrera: 1
        },
        rules:{
          nombre: [
            v => !!v || 'El nombre es necesario',
            v => (v && v.length >= 3) || 'El nombre debe de tener 3 caracteres o mas.'
          ],
          apellidos:[
            v => !!v || 'Los apellidos son necesarios',
            v => (v && v.length >= 3) || 'Los apellidos deben de tener 3 caracteres o mas.'
          ],
          dni: [
            v => !!v || 'El dni es necesario',
            v =>/(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))/.test(v) ||
                    "El formato no es correcto (ej. 12345678A)"
          ],
          localidad: [
            v => !!v || 'La localidad de residencia la necesitamos',
            v => (v && v.length >= 3) || 'Debe de tener 3 caracteres o mas.'
          ],
          sexo: [
            v => !!v || 'Es necesario para poder continuar',
          ],
          email: [
            v => !!v || 'El email es necesario para poder contactar',
            v => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(v)
                    || 'El email no tiene el formato correcto'
          ],
          tlfno: [
            v => !!v || 'Es necesario por si necesitamos contactar',
            v => /^\d+$/.test(v) || 'Solo se aceptan números',
            v => (v && v.length == 9) || 'Debe de tener 9 numeros sin espacios.'
          ],
          nombre_tutor:[
            v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
            v => { if ( this.isMenor ) return (v && v.length > 10) || "Por lo menos 10 carácteres"; else return !!v },
          ],
          dni_tutor:[
            v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
            v => { if ( this.isMenor ) return /(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))/.test(v) ||
                    "El formato no es correcto (ej. 12345678A)"; else return !!v },
          ],
          tlfno_tutor:[
            v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
            v => { if ( this.isMenor ) return /^\d+$/.test(v) || "Solo se aceptan números"; else return !!v },
            v => { if ( this.isMenor ) return (v && v.length == 9) || 'Debe de tener 9 numeros sin espacios.'; else return !!v },
          ],
          socio: [
            v => !!v || 'Es necesario para poder continuar',
          ],
          marca: [
            v => !!v || 'Es necesario para poder continuar',
          ],
          federado: [
            v => !!v || 'Esta información necesitamos saberla',
          ],
          licencia: [
            v => {  if(this.persona.federado === "SI") return !!v || 'Debe de ser un número de liciencia valido'; else return !!v}
          ],
          camiseta: [
            v => !!v || 'Necesitamos saber si quieres o no camiseta',
          ],
          talla: [
            //v => !!v || 'Necesitamos saber la talla de la camiseta' ,
            v => {  if(this.persona.camiseta === "SI") return !!v || 'Necesitamos saber la talla de la camiseta'; else return !!v}
          ],
          ducha: [
            v => !!v || 'Necesitamos saber si vas a usar el servicio de duchas o no',
          ],
          condiciones: [
            v => !!v || 'Tienes que leer y aceptar las condiciones de la carrera',
          ]
        }
      }
    },

    created() {
      //insService.getCategories('10K').then( cat => this.categorias = cat )
      this.categorias = cat.diez
      this.tallas = tallas.diez
      if (this.$store.state.inscritos.length != 0) this.multiple = true
    },
    mounted() {
      this.isValid = false
    },

    components: {
      datePicker: DatepickerComponent
    },
    methods: {

      ...mapGetters(['getInscritos']),
      ...mapActions(['addPerson', 'delPerson', 'addReference', 'delReference']),

      recuperaInscripcion() {
        insService.getInscripcion(this.recuperarDni).then(corredor => {

          if(corredor) {
            Object.keys(corredor).forEach((key) => {
                this.persona[key] = corredor[key]
            })
            this.asignarFecha(this.persona.fnac.split('-').reverse().join('-'))
            this.recuperar = false
            this.validarForm()
            this.noEncontrado = false
          }else{
            this.noEncontrado = true
          }
        })
      },

      asignarFecha(fecha) {
        this.currentDate = fecha
        this.viewDate = false
        setTimeout(() => {
          this.viewDate = true;
          this.cambia(moment(this.currentDate))
        }, 100)
      },

      cambia(data) {

        const today = moment()

        const edad = today.diff(data, 'years')
        const edadCarrera = this.diaCarrera.diff(data, 'years')


        if (edad < 18) this.isMenor = true; else this.isMenor = false;

        switch (true) {
          case edadCarrera < 35:
            this.persona.idCategoria = this.categorias[0].id;
            break;
          case edadCarrera >= 35 && edadCarrera < 45:
            this.persona.idCategoria = this.categorias[1].id;
            break;
          case edadCarrera >= 45 && edadCarrera < 55:
            this.persona.idCategoria = this.categorias[2].id;
            break;
          case edadCarrera >= 55:
            this.persona.idCategoria = this.categorias[3].id;
            break;
          default:
            break;
        }
        this.persona.fnac = data.format("YYYY-MM-DD")
        this.persona.menor = this.isMenor ? 'SI' : 'NO'
        this.persona.menor = this.isMenor ? 'SI' : 'NO'


      },

      cambiaFederado() {
        if(this.persona.federado === 'NO') this.persona.licencia = ''
      },

      cambiaSocio() {
        if (this.persona.socio === 'SI')
          this.persona.camiseta = 'SI'
        else
          this.persona.camiseta = ''
      },

      cambiaCamiseta() {
        if (this.persona.camiseta === 'NO') this.persona.talla = ''
      },

      validarForm() {
        this.$refs.rosconForm.resetValidation()
        this.isValid = this.$refs.rosconForm.validate()

      },

      reset() {
        //this.$v.$reset()
        this.persona = {
          nombre: '',
          apellidos: '',
          fnac: '',
          dni: '',
          localidad: '',
          genero: '',
          email: '',
          tlfno: '',
          socio: '',
          nombre_tutor: '',
          dni_tutor: '',
          tlfno_tutor: '',
          categoria: '',
          marca: '',
          apodo: '',
          federado: '',
          licencia: '',
          club: '',
          camiseta: '',
          talla: '',
          ducha: '',
          observaciones: '',
          condiciones: false,
          menor: false
        }
        this.recuperarDni = ''
        this.viewDate = false
        this.currentDate = null
        setTimeout(() => this.viewDate = true, 100)
      },

      borrarCorredor(dni) {
        this.delPerson(dni).then(() => {
          if (this.$store.state.inscritos.length === 0) {
            this.multiple = false
            if (this.$store.state.referencia) this.delReference()
          }
          if (this.$store.state.referencia !== null) {
            insService.deleteInscripcion(dni)
          }
        })
      },

      agregarCorredor() {

        if(this.$refs.rosconForm.validate()){
          this.addPerson(this.persona) .then(rdo => {
            //eslint-disable-next-line
            console.log(rdo)
            this.reset()
            this.multiple = true
            if (this.$store.state.referencia !== null) {
              const data = {
                referencia: this.$store.state.referencia,
                inscrito: this.persona
              }
              insService.appendInscripcion(data).then( rdo => {
                //eslint-disable-next-line
                console.log(rdo)
              })
            }

            this.$vuetify.goTo(0, { duration:600, offset:0 })
          })
        }

      },

      pagar() {
        if(this.$refs.rosconForm.validate()){
          this.addPerson(this.persona) .then(rdo => {
            if(rdo.inscritos) {
              if(this.$store.state.referencia === null){
                insService.generateInscripcion(this.$store.state.inscritos).then( a => {

                  if(a.error){

                    this.delPerson(this.persona.dni).then( () =>
                            this.duplicado = true
                    )
                  }else {
                    this.$router.push({
                      name: 'resumen',
                      params: {referencia: a.referencia, tipo: 'roscon' }
                    })
                  }
                })
              }else {
                const data = {
                  referencia: this.$store.state.referencia,
                  inscrito: this.persona
                }
                insService.appendInscripcion(data).then( rdo => {
                  //eslint-disable-next-line
                  console.log(rdo)
                  if(rdo.error){
                    this.delPerson(this.persona.dni).then( () =>
                            this.duplicado = true
                    )

                  }else{
                    this.$router.push({
                      name: 'resumen',
                      params: { referencia: this.$store.state.referencia, tipo: 'roscon' }
                    })
                  }
                })
              }
            }
          })
        }
      },

      guardarInscripcion() {
        if (this.$store.state.referencia !== null) {
          this.$router.push({
            name: 'resumen',
            params: { referencia: this.$store.state.referencia, tipo:'roscon' }
          })
        } else {
          insService.generateInscripcion(this.$store.state.inscritos).then(rdo => {
            if (!rdo.error)
              this.addReference(rdo.referencia).then(adResult => {

                if (!adResult.error)
                  return adResult
                else
                  alert(adResult.msg)
              })
            //eslint-disable-next-line
          }).catch(err => alert(err))
        }
      },

      irResumen() {
        if (this.$store.state.referencia !== null)
          this.$router.push({
            name: 'resumen',
            params: { referencia: this.$store.state.referencia, tipo: 'roscon' }
          })
        else this.guardarInscripcion()
      },

    }

  }
</script>

<style>

</style>